import React from "react";
import "./MonitorImpressaoPage.css";

import PageContainer from "../../components/geral/PageContainer";

const MonitorImpressaoPage = () => {
  return (
    <PageContainer>
      <div className="monitor-impressao-card">
        <img
          src="/images/printer.png"
          alt="Impressora"
          className="monitor-impressao-img"
        />
        <h2>Monitor de Impressão</h2>
        <p>
          O monitor está rodando automaticamente em background enquanto você
          estiver logado no sistema.
        </p>
      </div>
    </PageContainer>
  );
};

export default MonitorImpressaoPage;